import { Platform } from 'react-native';
import RNConfig from 'react-native-config';

const Config: Record<string, string> =
  Platform.OS === 'web'
    ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      WEB_CONFIG
    : RNConfig;

export const config = {
  SENTRY_DSN: Config.SENTRY_DSN,
  ENV: Config.ENV,
  API_URL: Config.API_URL,
  APP_URL: Config.APP_URL,
  AMPLITUDE_KEY: Config.AMPLITUDE_KEY,
  // NOTE: STRIPE_KEY is WEB only prop and it is missing in CI/CD configs for the mobile side,
  // if you need this prop on Android/iOS please update CI/CD configs
  STRIPE_KEY: Config.STRIPE_KEY,
  // NOTE: BRAZE_WEB_API_KEY is WEB only prop and it is missing in CI/CD configs for the mobile side, please take a look at other props
  // if you need this prop on Android/iOS please update CI/CD configs
  BRAZE_WEB_API_KEY: Config.BRAZE_WEB_API_KEY,
  BRAZE_SDK_ENDPOINT: Config.BRAZE_SDK_ENDPOINT,
  // NOTE: GOOGLE_TAG_MANAGER_ID is WEB only prop and it is missing in CI/CD configs for the mobile side,
  // if you need this prop on Android/iOS please update CI/CD configs
  GOOGLE_TAG_MANAGER_ID: Config.GOOGLE_TAG_MANAGER_ID,
};
